import { SiteIdOverrideConfig } from "stores/wizard/config";
import { timeValues24HoursFormat } from "src/components/shared/TimeDropdown/config/time/timeValues";

export const siteId70928: SiteIdOverrideConfig = {
  global: {
    heroImageSrc: "https://a.travel-assets.com/travel-assets-manager/cmct-2135/JP_Autumn_Osaka_1400x600.jpg",
  },
  package: {
    showAllSubLOB: false,
  },
  car: {
    location: {
      destination: {
        inputName: "returnName",
      },
      origin: {
        inputName: "pickupName",
      },
    },
    date: {
      queryParam: {
        start: "",
        end: "",
      },
    },
    form: {
      action: "https://cars.cartrawler.com/expedia/{locale}_JP/book#/vehicles",
    },
    isCarTrawler: true,
    showVendorOptions: false,
    clientID: 791862,
    residenceID: "JP",
    timeValues: timeValues24HoursFormat,
    defaultShowingTime: "10:30",
    includeGT: false,
  },
  hotel: {
    useDialogTextWithoutCar: true,
    packageRatesTermsUrl: "/static/default/default/taap/contracts/hpr/JP.HPR.012021.pdf",
  },
};
